module.exports = __webpack_public_path__ + "static/workflow-management-c9d8013e69808fe45d9399b575bc9afe.png";